export const shallowEqual = <T extends object>(objA: T, objB: T): boolean =>
    Object.keys(objA).length === Object.keys(objB).length &&
    Object.keys(objA).every(key => objA[key as keyof T] === objB[key as keyof T]);
